import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import routes from "../../../constants/routes";

const CreateToken2 = () => {
    const { t } = useTranslation();


    return (
        <div className="pages-createToken2">
            <div className="box">
                <div className="top">
                    <div className="left">{t("createToken.Manage list")}</div>
                    <Link
                        to={routes.createToken3}
                        className="right g-buttonHover"
                    >
                        {t("createToken.Create my Token")}
                    </Link>
                </div>
                <form className="search">
                    <button>
                        <img src="/images/search.svg" alt="" />
                    </button>
                    <input
                        name="search"
                        placeholder={t("createToken.Search")}
                    />
                </form>
                <div className="items">
                    <div className="item">
                        <div className="image">
                            <img src="/images/wallet4.svg" alt="" />
                        </div>
                        <div className="text">
                            <div className="title">BSC</div>
                            <div className="content">
                                <span>10.</span>007318
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src="/images/wallet5.svg" alt="" />
                        </div>
                        <div className="text">
                            <div className="title">Space</div>
                            <div className="content">
                                <span>10.</span>007318
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src="/images/wallet6.svg" alt="" />
                        </div>
                        <div className="text">
                            <div className="title">Energy</div>
                            <div className="content">
                                <span>10.</span>007318
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src="/images/token1.svg" alt="" />
                        </div>
                        <div className="text">
                            <div className="title">Energy</div>
                            <div className="content">
                                <span>10.</span>007318
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="image">
                            <img src="/images/token2.svg" alt="" />
                        </div>
                        <div className="text">
                            <div className="title">Bisswap</div>
                            <div className="content">
                                <span>10.</span>007318
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateToken2;
